var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "pipScroll",
    staticClass: "participantSetting scrollbar",
    attrs: {
      "id": "myScroll"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "settingCate"
  }, [_c('i', {
    staticClass: "iconfont icon-a-TypesignStategeneral"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('setting.generalControl')))])]), _vm.$route.name === 'party' || _vm.$route.name == 'group' || _vm.$route.name == 'newgroup' || _vm.$route.name == 'coordinator' || _vm.$route.name == 'kiosk' || _vm.$route.name == 'manage' && (_vm.State.currentModule == 'group' || _vm.State.currentModule == 'party') ? _c('div', {
    staticClass: "anywhereSetting"
  }, [_c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.globalAnywhereSetting')))]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.changeGlobalAnyWhereSetting
    },
    model: {
      value: _vm.defaultSwitch.globalAnyWhereSetting,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "globalAnyWhereSetting", $$v);
      },
      expression: "defaultSwitch.globalAnyWhereSetting"
    }
  })], 1), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOn')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('setting.globalAnywhereSettingText')))])])]), _vm.defaultSwitch.globalAnyWhereSetting ? _c('div', {
    staticClass: "operation"
  }, [_c('div', {
    staticClass: "anyWhereSelect"
  }, [_c('div', {
    staticClass: "resolutionBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("commonSetting.resolution")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('resolutionFps', _vm.resolution);
      }
    },
    model: {
      value: _vm.resolution,
      callback: function ($$v) {
        _vm.resolution = $$v;
      },
      expression: "resolution"
    }
  }, _vm._l(_vm.resolutionOptions, function (item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.label,
        "disabled": item.disabled
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "framesRateBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.framesRate")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('resolutionFps');
      }
    },
    model: {
      value: _vm.fps,
      callback: function ($$v) {
        _vm.fps = $$v;
      },
      expression: "fps"
    }
  }, _vm._l(_vm.computedFpsOptions, function (item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "switchCameraBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.switchCamera")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('switchCamera');
      }
    },
    model: {
      value: _vm.cameraPosition,
      callback: function ($$v) {
        _vm.cameraPosition = $$v;
      },
      expression: "cameraPosition"
    }
  }, _vm._l(_vm.cameraOptions, function (item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": _vm.$t(`anywhereSetting.${item.label}`),
        "value": item.value
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "defaultViewBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.defaultView")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('defaultView');
      }
    },
    model: {
      value: _vm.defaultView,
      callback: function ($$v) {
        _vm.defaultView = $$v;
      },
      expression: "defaultView"
    }
  }, _vm._l(_vm.defaultViewOptions, function (item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": _vm.$t(`anywhereSetting.${item.label}`),
        "value": item.value
      }
    });
  }), 1)], 1)]), _c('div', {
    staticClass: "lockApp"
  }, [_c('div', {
    staticClass: "lockAppTitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.lockApps")))]), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('anywhereSetting.lockAppTitle'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  })])], 1), _c('el-switch', {
    attrs: {
      "active-value": '1',
      "inactive-value": '0',
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('lockScreen');
      }
    },
    model: {
      value: _vm.locked,
      callback: function ($$v) {
        _vm.locked = $$v;
      },
      expression: "locked"
    }
  })], 1)]) : _vm._e(), _c('el-divider')], 1) : _vm._e(), _vm.$route.name === 'party' || _vm.State.currentModule == 'party' ? _c('div', {
    staticClass: "volimeEffect"
  }, [_c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.volimeEffect')))]), _c('el-select', {
    attrs: {
      "popper-class": "setVolumEffect"
    },
    on: {
      "change": _vm.updateVolumeStyle
    },
    model: {
      value: _vm.defaultSwitch.isAudioLevel,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "isAudioLevel", $$v);
      },
      expression: "defaultSwitch.isAudioLevel"
    }
  }, _vm._l(_vm.VolumEffects, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.$t(`setting.${item.label}`),
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-divider')], 1) : _vm._e(), _vm.$route.name === 'party' || _vm.$route.name == 'manage' && _vm.State.currentModule == 'party' ? _c('div', {
    staticClass: "intercom"
  }, [_c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.intercom')))]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "disabled": _vm.State.audioMatrixEnable || _vm.State.pushTalkEnable,
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.changeParticipantsPrivate
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.showMutexTip.apply(null, arguments);
      }
    },
    model: {
      value: _vm.defaultSwitch.intercom,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "intercom", $$v);
      },
      expression: "defaultSwitch.intercom"
    }
  })], 1), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOn')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('setting.openParticipantPrivat')))])])]), _c('p', {
    staticClass: "intercomNote"
  }, [_vm._v(_vm._s(_vm.$t('setting.intercomNote')))]), _c('el-divider')], 1) : _vm._e(), _c('div', {
    staticClass: "participantName"
  }, [_c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.participantName')))]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.changeLockPipName
    },
    model: {
      value: _vm.defaultSwitch.participantName,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "participantName", $$v);
      },
      expression: "defaultSwitch.participantName"
    }
  })], 1), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOff')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('setting.lockName')))])])])]), _c('div', {
    staticClass: "partyLinkShare"
  }, [_c('el-divider'), _c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.partyLink')))]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.changePipCopyBtn
    },
    model: {
      value: _vm.defaultSwitch.partyLinkShare,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "partyLinkShare", $$v);
      },
      expression: "defaultSwitch.partyLinkShare"
    }
  })], 1), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOff')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('setting.lockCopy')))])])])], 1), _vm.$route.name === 'kiosk' || _vm.$route.name == 'manage' && _vm.State.currentModule == 'kiosk' ? _c('div', {
    staticClass: "partyLinkShare"
  }, [_c('el-divider'), _c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.fullScreen')))]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.changePipFullScreen
    },
    model: {
      value: _vm.defaultSwitch.fullScreen,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "fullScreen", $$v);
      },
      expression: "defaultSwitch.fullScreen"
    }
  })], 1), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOff')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('setting.fullScreenTips')))])])])], 1) : _vm._e(), _c('div', {
    staticClass: "partyLinkShare"
  }, [_c('el-divider'), _c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.loginAndRegister')))]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.changePipLoginOrRes
    },
    model: {
      value: _vm.defaultSwitch.logOrRes,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "logOrRes", $$v);
      },
      expression: "defaultSwitch.logOrRes"
    }
  })], 1), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOff')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('setting.loginButton')) + " " + _vm._s(_vm.$t('setting.loginFunction')))])])])], 1), _c('div', {
    staticClass: "muteAll"
  }, [_c('el-divider'), _c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.muteAll')))]), _c('el-button', {
    staticClass: "green",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.sendMuteAll
    }
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.apply')))])], 1), _c('div', {
    staticClass: "text"
  }, [_c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('setting.muteAllTips1')))]), _c('li', [_vm._v(_vm._s(_vm.$t('setting.muteAllTips2')))])])])], 1), _vm.$route.name === 'kiosk' || _vm.$route.name == 'manage' && _vm.State.currentModule == 'kiosk' ? _c('div', {
    staticClass: "partyLinkShare"
  }, [_c('el-divider'), _c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.micAndCamera')))]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.changePipMicOrCamera
    },
    model: {
      value: _vm.defaultSwitch.micOrCameraOperation,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "micOrCameraOperation", $$v);
      },
      expression: "defaultSwitch.micOrCameraOperation"
    }
  })], 1), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOff')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('setting.micAndCameraTips')))])])])], 1) : _vm._e(), _vm.$route.name !== 'group' && _vm.$route.name !== 'newgroup' && !(_vm.$route.name == 'manage' && _vm.State.currentModule == 'group') ? _c('div', {
    staticClass: "resolutionSet"
  }, [_c('el-divider'), _c('div', {
    staticClass: "settingCate"
  }, [_c('i', {
    staticClass: "iconfont icon-a-TypesignStateadvanced"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('setting.advanceControl')))])]), _c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.highResolution')))]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.changeResolution
    },
    model: {
      value: _vm.defaultSwitch.value,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "value", $$v);
      },
      expression: "defaultSwitch.value"
    }
  })], 1), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOnHighResolution')))]), _vm._m(0), _c('p', {
    staticClass: "titleOne"
  }, [_vm._v(" " + _vm._s(_vm.$t('setting.selectHighResolution')) + " ")]), _c('p', {
    staticClass: "titleTwo"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOffHighResolution')))]), _vm._m(1), _c('p', {
    staticClass: "titleThree"
  }, [_vm._v(_vm._s(_vm.$t('setting.defaultResolution')))])])], 1) : _vm._e(), _vm.$route.name === 'party' || _vm.$route.name == 'manage' && _vm.State.currentModule == 'party' ? _c('div', {
    staticClass: "lazyAudio"
  }, [_c('el-divider'), _c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('commonSetting.lazyAudio')) + " "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Ctrl+L")])]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.changeLazyAudio
    },
    model: {
      value: _vm.defaultSwitch.valueAudio,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "valueAudio", $$v);
      },
      expression: "defaultSwitch.valueAudio"
    }
  })], 1), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOn')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('setting.lazyAudioOn')))]), _c('li', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('setting.terminalReceiver')))]), _c('li', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('setting.otherParticipantHear')))])])])], 1) : _vm._e(), _vm.$route.name === 'party' || _vm.$route.name == 'manage' && _vm.State.currentModule == 'party' ? _c('div', {
    staticClass: "partyLinkShare"
  }, [_c('el-divider'), _c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.audioFeedBack')))]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.changePipCanHear
    },
    model: {
      value: _vm.defaultSwitch.hearParticipant,
      callback: function ($$v) {
        _vm.$set(_vm.defaultSwitch, "hearParticipant", $$v);
      },
      expression: "defaultSwitch.hearParticipant"
    }
  })], 1), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOn')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('setting.hearThemselves')))])])])], 1) : _vm._e()])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("480p 30fps 750k-1000k")]), _c('li', [_vm._v("720p 30fps 2000k-2300k")]), _c('li', [_vm._v("1080p 30fps 3000k-3200k")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("360p 30fps,600k-1000k")])]);
}];
export { render, staticRenderFns };